import styled from 'styled-components';

export const StyledResetForm = styled.div`
  width: 100%;

  .reset-form {
    width: 100%;
    justify-content: center;

    &__header {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      margin-bottom: 32px;
    }

    &__icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: linear-gradient(
        135deg,
        ${({ theme }) => theme.colors.mainBlue},
        ${({ theme }) => theme.colors.mariner}
      );
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.colors.white};
      font-size: 1.4rem;
      margin-bottom: 4px;
    }

    &__title {
      text-align: center;

      p {
        font-size: 1.75rem;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.codGray};
      }
    }

    &__subtitle {
      text-align: center;

      p {
        color: ${({ theme }) => theme.colors.raven};
        font-size: 0.9rem;
        line-height: 1.5;
      }
    }

    &__item {
      margin-bottom: 4px;
    }

    &__submit {
      margin-top: 32px;

      button {
        width: 100%;
      }
    }
  }
`;
